import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Icons from "../icons";

const Pagination = ({ currentPage, totalPages, pageCallBack }) => {
  const [pageLists, setPageLists] = useState([]);
  const visibleItems = 5;
  const createPagesCounter = () => {
    const pages = [];
    for (let i = currentPage - visibleItems; i < totalPages; i++) {
      if (i >= 0 && i <= totalPages) {
        if (
          currentPage > Math.floor(visibleItems / 2) &&
          currentPage < totalPages - Math.floor(visibleItems / 2)
        ) {
          if (Math.abs(i - currentPage) < Math.ceil(visibleItems / 2)) {
            pages.push(i);
          }
        } else {
          if (Math.abs(i - currentPage) < visibleItems) {
            pages.push(i);
          }
        }
        if (pages.length === visibleItems) {
          break;
        }
      }
    }
    setPageLists(pages);
  };
  useEffect(() => {
    createPagesCounter();
  }, [currentPage, totalPages]);
  return (
    <div id="pagination" className="paginationWrapper d-flex">
      {totalPages > 0 && (
        <>
          <button
            id="pagination_back"
            className="roundBtn circle"
            disabled={currentPage === 0}
            onClick={() => pageCallBack(currentPage - 1)}
          >
            {Icons.leftArrowIcon}
          </button>
          {currentPage >= visibleItems-2 && totalPages > visibleItems && (
            <div className="roundBtn dots">...</div>
          )}
          {pageLists.map((item) => (
            <button
              id={"pagination_page_"+item}
              className={classNames(`roundBtn circle ${"pagination_page_"+item}`, {
                active: currentPage === item,
              })}
              key={`page_${item}`}
              onClick={() => pageCallBack(item)}
            >
              {item + 1}
            </button>
          ))}
          {totalPages > visibleItems && (
            <div className="roundBtn dots">...</div>
          )}
          <button
            id="pagination_next"
            className="roundBtn circle"
            disabled={currentPage === totalPages - 1}
            onClick={() => pageCallBack(currentPage + 1)}
          >
            {Icons.rightArrowIcon}
          </button>
        </>
      )}
    </div>
  );
};

export default Pagination;
